export const ONCOLOGY_ROUTES = {
  tac                : 'formulario/tac',
  historyPatient     : 'historial/paciente',
  historyProfessional: 'historial/profesional',
  radiotherapy       : 'formulario/radioterapia',
  roadmap            : 'formulario/quimioterapia-hoja-ruta-ceca',
};
